import { useState } from 'react'
import { Mail, ChevronRight, Headphones } from 'lucide-react'
import { FILL_GRADIENT } from '../constants/gradients'
import { SUPPORT_CONTACTS } from '../config/support'

const WhatsAppIcon = ({ size = 24, color = '#25D366' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"
      fill={color}
    />
  </svg>
)

const DiscordIcon = ({ size = 24, color = '#5865F2' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.955 2.418-2.157 2.418z"
      fill={color}
    />
  </svg>
)

const TelegramIcon = ({ size = 24, color = '#0088CC' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
      fill={color}
    />
  </svg>
)

type ContactEntry = {
  key: string
  label: string
  subtitle: string
  color: string
  url: string
  Icon: React.FC<{ size?: number; color?: string }>
}

const CONTACTS: ContactEntry[] = [
  {
    key: 'discord',
    label: 'Discord',
    subtitle: 'Join our community server for support & updates',
    color: '#5865F2',
    url: SUPPORT_CONTACTS.discord.url,
    Icon: DiscordIcon,
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    subtitle: 'Chat with us on WhatsApp for fast support',
    color: '#25D366',
    url: SUPPORT_CONTACTS.whatsapp.url,
    Icon: WhatsAppIcon,
  },
  {
    key: 'telegram',
    label: 'Telegram',
    subtitle: 'Message our support bot on Telegram',
    color: '#0088CC',
    url: SUPPORT_CONTACTS.telegram.url,
    Icon: TelegramIcon,
  },
  {
    key: 'email',
    label: 'Email',
    subtitle: SUPPORT_CONTACTS.email.address,
    color: '#EA4335',
    url: SUPPORT_CONTACTS.email.url,
    Icon: ({ size = 24, color = '#EA4335' }) => <Mail size={size} color={color} />,
  },
]

const SupportPage = () => {
  const [hoveredContact, setHoveredContact] = useState<string | null>(null)

  const handleContactClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="bg-gray-50 dark:bg-dark-bg min-h-full">
      <div className="max-w-3xl mx-auto p-8">
        {/* Header section */}
        <div className="text-center mb-10">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: FILL_GRADIENT }}
          >
            <Headphones className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-dark-text mb-3">
            We're here to help
          </h1>
          <p className="text-gray-500 dark:text-dark-text-muted text-base leading-relaxed max-w-md mx-auto">
            Reach out to the Beemi team through your preferred channel and we'll get you sorted as
            quickly as possible.
          </p>
        </div>

        {/* Direct contact options */}
        <div className="bg-white dark:bg-dark-surface border border-gray-200 dark:border-dark-border rounded-2xl overflow-hidden mb-6">
          <div className="px-6 py-4 border-b border-gray-100 dark:border-dark-border">
            <h2 className="text-base font-semibold text-gray-900 dark:text-dark-text">
              Contact us directly
            </h2>
          </div>
          <div className="divide-y divide-gray-100 dark:divide-dark-border">
            {CONTACTS.map(({ key, label, subtitle, color, url, Icon }) => (
              <button
                key={key}
                onClick={() => handleContactClick(url)}
                onMouseEnter={() => setHoveredContact(key)}
                onMouseLeave={() => setHoveredContact(null)}
                className="w-full flex items-center gap-4 px-6 py-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors text-left group"
              >
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105"
                  style={{ backgroundColor: `${color}18` }}
                >
                  <Icon size={22} color={hoveredContact === key ? color : color} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-900 dark:text-dark-text text-sm">{label}</p>
                  <p className="text-xs text-gray-500 dark:text-dark-text-muted mt-0.5 truncate">
                    {subtitle}
                  </p>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors flex-shrink-0" />
              </button>
            ))}
          </div>
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 dark:text-gray-600 mt-8">
          Our team typically responds within a few hours during business hours.
        </p>
      </div>
    </div>
  )
}

export default SupportPage
